import { useMemo } from 'react'
import { slugs } from '@/constants/slugs'

interface BasicHeroData {
  bgVideoUrl: string
  fallbackImageUrl: string
  logo: {
    url: string
    class: string
    width: number
    height: number
  }
}

const data = {
  [slugs.david]: {
    bgVideoUrl:
      'https://images.angelstudios.com/video/upload/q_auto:eco,f_auto,br_2m/v1765245269/david-bg-video_jmtkhw.mp4',
    fallbackImageUrl: '/v1760542947/theatrical/david/david-hand-img-01.webp',
    logo: {
      url: '/v1764102078/theatrical/david/david-logo-color-800m.webp',
      class: 'h-[45px] w-[180px] md:h-[45px] md:w-[180px] lg:h-[66px] lg:w-[265px]',
      width: 265,
      height: 66,
    },
  },
  [slugs.soloMio]: {
    bgVideoUrl:
      'https://images.angelstudios.com/video/upload/v1770139862/solo%20mio/solo-mio_tLoopingVideo_NewTrailer_wNOCAPS_16x9_f23_y20260203_iTD-lowres.mp4',
    fallbackImageUrl: '/v1770081649/solo%20mio/20251222_Solo_Mio_approved_frame-grab_00163291-lowres',
    logo: {
      url: '/v1769018193/studio-app/catalog/36205ab2-e580-4066-9e4a-301620298495',
      class: 'h-[33px] w-[253px] md:h-[36px] md:w-[278px] lg:h-[48px] lg:w-[369px]',
      width: 369,
      height: 48,
    },
  },
  [slugs.iWasAStranger]: {
    bgVideoUrl:
      'https://images.angelstudios.com/video/upload/v1766007929/theatrical/stranger/stranger-loop-video-v2.mp4',
    fallbackImageUrl: '/v1766081312/theatrical/stranger/stranger-loop-img-01.png',
    logo: {
      url: '/v1758752785/studio-app/catalog/90767562-3c8f-4e42-a40a-d0bcab0e685e',
      class: 'h-[57px] w-[188px] md:h-[67px] md:w-[220px] lg:h-[81px] lg:w-[265px]',
      width: 265,
      height: 81,
    },
  },
}

export const useBasicHeroData = (slug: string): BasicHeroData | null => {
  return useMemo(() => data[slug] ?? null, [slug])
}
